import { createFileRoute } from "@tanstack/react-router";
import FounderSOP from "@/pages/FounderSOP";

export const Route = createFileRoute("/accelerator/sop/")({
  component: FounderSOP,
});
